// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { css } from "styled-components";

productImageStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        min-height: 18px;
        min-width: 86px;
        width: fit-content;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        & > div {
            padding: 0;
        }
    `,
};

productImageStyles.badgeText = {
    weight: 400,
    size: 10,
    lineHeight: "12px",
    css: css`
        text-transform: uppercase;
        letter-spacing: 0.55px;
    `,
};

productImageStyles.badgeImageWrapper = {
    css: css`
        position: absolute;
        width: 25%;
        height: auto;
    `,
};
